/* eslint-disable arrow-body-style */
import { Box, Typography , Stack , MenuItem } from '@mui/material';
// utils
import { fDate } from '../../../../utils/formatTime';
// @types
// components
import Image from '../../../../components/Image';
import TextMaxLine from '../../../../components/TextMaxLine';
import SvgIconStyle from '../../../../components/SvgIconStyle';
import { Category } from 'src/@types/Category';
import { StyledAvatar, StyledCardContainer, StyledCardContent } from '../styles';

import { TableMoreMenu } from 'src/components/table';

import { useState } from 'react';
import Iconify from 'src/components/Iconify';
import Label from 'src/components/Label';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

type Props = {
  category: Category;
  index?: number;
  handleEditRow(): void;
  handleDeleteRow(): void;
};

export default function CategoryCard({ category, index, handleDeleteRow, handleEditRow }: Props) {
  return (
    <StyledCardContainer>
      <Box sx={{ position: 'relative' }}>
        <SvgIconStyle
          src="https://minimal-assets-api-dev.vercel.app/assets/icons/shape-avatar.svg"
          sx={{
            zIndex: 9,
            width: 80,
            height: 36,
            bottom: -15,
            position: 'absolute',
            color: 'background.paper',
          }}
        />
        <StyledAvatar alt={category.title} src={category.icon} />
        <Image alt="cover" src={category.image} ratio="4/3" />
      </Box>

      <CategoryContent
        category={category}
        handleDeleteRow={handleDeleteRow}
        handleEditRow={handleEditRow}
      />
    </StyledCardContainer>
  );
}

// ----------------------------------------------------------------------

type CategoryContentProps = {
  category: Category;
  handleEditRow(): void;
  handleDeleteRow(): void;
};

function CategoryContent({ category, handleEditRow, handleDeleteRow }: CategoryContentProps) {
  return (
    <StyledCardContent>
      <Stack>
        <Stack direction={'row'} alignItems={'center'} spacing={1} sx={{ mb: 0.5 }}>
          <Typography variant="caption" component="div" color={'text.disabled'}>
            {fDate(category.createdAt as string)}
          </Typography>
          {/* categories-order-reset C1: the website lists paths by this order. */}
          <Label color="default" variant="ghost" data-testid="path-card-order">
            {typeof category.order === 'number' ? `Order ${category.order}` : 'No order'}
          </Label>
          {category.showOnHome === false ? (
            <Label color="warning" variant="ghost" data-testid="path-card-hidden-home">
              Hidden on home
            </Label>
          ) : null}
        </Stack>
        <Stack direction={'row'} width={'100%'} justifyContent={'space-between'}>
          <TextMaxLine sx={{ width: 'auto !important' }} variant={'subtitle2'} line={2} persistent>
            {category.title}
          </TextMaxLine>
          <ToolBar onEditRow={handleEditRow} onDeleteRow={handleDeleteRow} row={category} />
        </Stack>
        <Typography
          gutterBottom
          variant="caption"
          height={'150px'}
          component="div"
          color={'text.disabled'}
        >
          {category.description}
        </Typography>
      </Stack>
    </StyledCardContent>
  );
}

export const ToolBar = ({
  onEditRow,
  row,
  onDeleteRow,
}: {
  row: Category;
  onEditRow(): void;
  onDeleteRow(): void;
}) => {
  const [openMenu, setOpenMenuActions] = useState<HTMLElement | null>(null);

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setOpenMenuActions(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpenMenuActions(null);
  };

  return (
    <TableMoreMenu
      open={openMenu}
      onOpen={handleOpenMenu}
      onClose={handleCloseMenu}
      actions={
        <>
        
          <MenuItem
            onClick={() => {
              onEditRow();
              handleCloseMenu();
            }}
          >
            <Iconify icon={'eva:edit-fill'} />
            Edit
          </MenuItem>
          <MenuItem
            onClick={() => {
              onDeleteRow();
              handleCloseMenu();
            }}
            sx={{ color: 'error.main' }}
          >
            <Iconify icon={'eva:trash-2-outline'} />
            Delete
          </MenuItem>
        </>
      }
    />
  );
};
